import React, { Component } from 'react';
import { TextInput } from '../components/TextInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow';
import { validEmail, validPhone } from '../helpers/Validator.tsx';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    updateLead(props: any): void;
    firstname: string;
    email: string;
    phone1?: string;
    consent: boolean;
    applicant: number;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    email?: string;
    phone1?: string;
    consent?: boolean;
    emailnotification?:boolean;
}

export class CaptureContactDetails extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        // this.state = {hasError: false, email: this.props.email, phone: this.props.phone, consent: this.props.consent};
        this.state = {hasError: false, email: this.props.email, phone1: this.props.phone1, consent: this.props.consent, emailnotification:false};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep() {
        var issueWithPhoneOrConsent = false;
        if (this.props.applicant === 1) {
            issueWithPhoneOrConsent = !this.state.phone1; //|| !this.state.consent;
        }
        var errors:string[]=[];
        if (!this.state.email || issueWithPhoneOrConsent) {
            if (!this.state.email) {
                errors.push("Email is required");
            }
            if (issueWithPhoneOrConsent) {
                if (!this.state.phone1) {
                    errors.push("Phone is required");
                }
                // if (!this.state.consent) {
                //     errors.push("Consent is required")
                // }
            }
            this.setState({errors: errors, hasError: true});
            return;
        }
        if (validEmail(this.state.email)===false) {
            errors.push("Invalid email");
        }
        // if (validPhone(this.state.phone)===false) {
        //     errors.push("Invalid phone number");
        // }
        if (errors.length>0) {
            this.setState({errors: errors, hasError: true});
            return;
        }
        this.props.nextStep();
    }

    setEmail(v: string) {
        if (this.props.applicant === 1)
            this.props.updateLead({emailApplicant1: (v??'').trim()});
        else
            this.props.updateLead({emailApplicant2: (v??'').trim()});
    }

    render() {

        return (
            <header className="App-header">
                {this.props.applicant === 1 && <h1 className='l'><span className='doddltext'>Thanks {this.props.firstname},</span> where would you like<br />your options emailed?</h1>}
                {this.props.applicant === 2 && <h1 className='l'><span className='doddltext'>Please provide an email address for {this.props.firstname}</span><br />Needs to be different from your own email address</h1>}
                <h2 className='l'><span className='doddltext'>No spam, ever</span></h2>
                <div className='wrapper'>
                    <div className='row'>
                        <div className={`column2 ${this.props.applicant === 1 ? 'justify-e' : 'justify-c'}`}>
                            <TextInput
                                id='email'
                                value={this.props.email}
                                placeholder='Email'
                                classes={this.state.hasError && !this.state.email ? "e" : ""}
                                // onChange={(e) => { this.setState({email: e.target.value}); this.setEmail(e.target.value); }} />
                                onChange={(e) => { this.setState({email: e.target.value, emailnotification:true}); this.setEmail(e.target.value); }} />

                        </div>
                        {this.props.applicant === 1 &&
                            <div className='column2 justify-s'>
                                <TextInput
                                    id='phone'
                                    value={this.props.phone1}
                                    placeholder='Phone'
                                    classes={this.state.hasError && !this.state.phone1 ? "e" : ""}
                                    onChange={(e) => { this.setState({phone1: e.target.value}); this.props.updateLead({phone1: (e.target.value??'').trim()}); }} />

                            </div>
                        }
                    </div>
                    {/* {this.props.applicant === 1 &&
                        <div className='row'>
                            <div className='d-column'>
                            <input 
                                id='consent' 
                                type='checkbox' 
                                name='consent'
                                checked={this.props.consent}
                                className={this.state.hasError && !this.state.consent ? "e" : ""}
                                onChange={(e) => { this.setState({consent: e.target.checked}); this.props.updateLead({consentGiven: e.target.checked}); }} />
                            <label htmlFor='consent'>I consent for doddl to process the information I provide, and to contact me in relation to my mortgage and associated insurances as per the <a href='https://doddl.ie/privacy-notice/' target='_blank'>doddl privacy notice</a> and <a href='https://doddl.ie/terms-conditions/' target='_blank'>Terms of Business.</a></label>
                            </div>
                        </div>
                    } */}
                    {/* {this.state.emailnotification && <div>We will email you our Terms of Business and Data Privacy Notice in the next few minutes</div>} */}
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header>
        );
    }
}
